export type Address = {
    address: string;
    address2: string;
    city: string;
    country: string;
    firstName: string;
    lastName: string;
    mobileNumber: string;
    organizationName?: string;
    state: string;
    zip: string;
};

export const DefaultEmptyAddress = {
    address: '',
    address2: '',
    city: '',
    country: '',
    firstName: '',
    lastName: '',
    mobileNumber: '',
    organizationName: '',
    state: '',
    zip: '',
};
